import React, { useState, useEffect } from 'react';
import api from '../services/api';

const th = { padding: '0 12px 10px 0', color: '#9AA3AE', fontSize: '10.5px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px', textAlign: 'left', borderBottom: '0.5px solid rgba(26,58,92,0.1)' };
const td = { padding: '11px 12px 11px 0', borderBottom: '0.5px solid rgba(26,58,92,0.07)', fontSize: '13px', color: '#1C2533', verticalAlign: 'middle' };
const inpStyle = { padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };

// Remove o sufixo do JID para exibir só o número (mantém @lid quando não há telefone real).
const exibirNumero = (tel) => (tel || '').endsWith('@s.whatsapp.net') ? tel.split('@')[0] : tel;
const formatarData = (d) => d ? new Date(d).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';

export default function LeadsWhatsapp() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reativando, setReativando] = useState(null);
  const [numeroManual, setNumeroManual] = useState('');
  const [msg, setMsg] = useState(null);

  useEffect(() => { carregar(); }, []);

  const carregar = () => {
    setLoading(true);
    api.get('/whatsapp/transferidos')
      .then(r => setLeads(r.data))
      .catch(err => setMsg({ tipo: 'erro', texto: err.response?.data?.error || 'Erro ao carregar' }))
      .finally(() => setLoading(false));
  };

  const reativar = async (numero) => {
    if (!numero) return;
    if (!window.confirm(`Reativar o atendimento automático do bot para ${exibirNumero(numero)}?`)) return;
    setReativando(numero);
    setMsg(null);
    try {
      const r = await api.post('/whatsapp/reativar', { numero });
      setMsg({ tipo: 'ok', texto: `Bot reativado para ${r.data.reativados.map(exibirNumero).join(', ')}` });
      setNumeroManual('');
      carregar();
    } catch (err) {
      setMsg({ tipo: 'erro', texto: err.response?.data?.message || err.response?.data?.error || 'Erro ao reativar' });
    } finally { setReativando(null); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>
          Leads WhatsApp <span style={{ fontSize: '14px', color: '#6B7A8D', fontWeight: '400' }}>({leads.length})</span>
        </div>
        <button onClick={carregar} style={{ padding: '8px 14px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#1A3A5C', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
          ↻ Atualizar
        </button>
      </div>
      <div style={{ fontSize: '13px', color: '#6B7A8D', marginBottom: '18px' }}>
        Clientes transferidos para atendimento humano (o bot parou de responder). Reative quando o atendimento terminar.
      </div>

      {msg && (
        <div style={{ padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', background: msg.tipo === 'ok' ? '#EAF5EE' : '#FDECEA', color: msg.tipo === 'ok' ? '#2D7D4F' : '#C0392B', fontSize: '13px', fontWeight: '500' }}>
          {msg.texto}
        </div>
      )}

      {/* Reativação manual por número */}
      <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: '14px 18px', marginBottom: '16px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ fontSize: '12px', fontWeight: '600', color: '#6B7A8D' }}>Reativar por número:</span>
        <input value={numeroManual} onChange={e => setNumeroManual(e.target.value)} placeholder="ex: 5585991236443"
          style={{ ...inpStyle, width: '200px' }} />
        <button onClick={() => reativar(numeroManual.trim())} disabled={!numeroManual.trim() || reativando === numeroManual.trim()}
          style={{ padding: '8px 16px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", opacity: numeroManual.trim() ? 1 : 0.5 }}>
          Reativar
        </button>
      </div>

      <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: '16px 18px' }}>
        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#9AA3AE', fontSize: '13px' }}>Carregando...</div>
        ) : leads.length === 0 ? (
          <div style={{ padding: '24px', textAlign: 'center', color: '#9AA3AE', fontSize: '13px' }}>Nenhum lead em atendimento humano no momento. 🎉</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>{['Número', 'Interesse', 'Última mensagem', 'Transferido em', ''].map(h => <th key={h} style={th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {leads.map(l => (
                <tr key={l.telefone}>
                  <td style={{ ...td, fontWeight: '500' }}>{exibirNumero(l.telefone)}</td>
                  <td style={td}>
                    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600', background: '#E6F1FB', color: '#185FA5' }}>
                      {l.interesse || 'não identificado'}
                    </span>
                  </td>
                  <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', maxWidth: '280px' }}>{l.ultima_mensagem}</td>
                  <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', whiteSpace: 'nowrap' }}>{formatarData(l.transferido_em)}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <button onClick={() => reativar(l.telefone)} disabled={reativando === l.telefone}
                      style={{ padding: '5px 12px', background: '#2D7D4F', border: 'none', color: '#fff', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                      {reativando === l.telefone ? '...' : '🤖 Reativar bot'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
